import { render, staticRenderFns } from "./Importados.vue?vue&type=template&id=a8f7a334&scoped=true&"
import script from "./Importados.vue?vue&type=script&lang=js&"
export * from "./Importados.vue?vue&type=script&lang=js&"
import style0 from "./Importados.vue?vue&type=style&index=0&id=a8f7a334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f7a334",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8f7a334')) {
      api.createRecord('a8f7a334', component.options)
    } else {
      api.reload('a8f7a334', component.options)
    }
    module.hot.accept("./Importados.vue?vue&type=template&id=a8f7a334&scoped=true&", function () {
      api.rerender('a8f7a334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Importacao/Pluggy/Importados.vue"
export default component.exports